import { Spacing, Text } from '@vkontakte/vkui';
import processImage from 'img/aiSetHelper/process.png';
import processImageDark from 'img/aiSetHelper/processDark.png';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import styles from 'reactApp/ui/AiSetFakedoorModal/AiSetFakedoorModal.css';
import { sendDwh } from 'reactApp/utils/ga';

const sendRadar = (action: 'show' | 'click' | 'close' = 'show') =>
    sendDwh({
        eventCategory: 'modal',
        action,
        dwhData: { name: 'fake_ai_functions_thanks' },
    });

export const AiSetOkModal = memo<{ onClose(): void }>(({ onClose }) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);

    const handleDismiss = useCallback(() => {
        sendRadar('close');
    }, []);

    const handleClick = useCallback(() => {
        sendRadar('click');
    }, []);

    const content = (
        <>
            <Spacing size={12} />
            <Text className={styles.text}>
                Спасибо за интерес — теперь знаем,
                <br />
                что для вас важно
            </Text>
            <Spacing size={24} />
        </>
    );

    return (
        <WhatsNewDialog
            primaryButtonText="Понятно"
            title="Мы ещё работаем над этими возможностями"
            imageUrl={isDarkTheme ? processImageDark : processImage}
            content={content}
            dialogSize="small"
            buttonTheme="vk"
            closeAfterClick
            onShow={sendRadar}
            onClose={onClose}
            onDismiss={handleDismiss}
            onClick={handleClick}
        />
    );
});

AiSetOkModal.displayName = 'AiSetOkModal';
